module.exports = __webpack_public_path__ + "static/media/addLeave.1c5a4a93.svg";